import { SAArtwork } from 'types/Artwork'

export const collectionArtworksTransformer = (
  artworks: ReadonlyArray<SAArtwork>
): ReadonlyArray<SAArtwork> =>
  artworks.map((artwork) => ({
    artId: artwork.artId || 0,
    artistArtworksUrl: artwork.artistArtworksUrl || '',
    artistRecognition: artwork.artistRecognition || [],
    artworkId: artwork.artworkId || 0,
    artworkRank: artwork.artworkRank || 0,
    artworkTitle: artwork.artworkTitle || '',
    artworkUrl: artwork.artworkUrl || '',
    aspectRatio: artwork.aspectRatio || 1,
    category: artwork.category || '',
    city: artwork.city || '',
    color: artwork.color || '',
    colorProximity: artwork.colorProximity || 0,
    country: artwork.country || '',
    curatedStatus: artwork.curatedStatus || 0,
    depth: artwork.depth || 0,
    firstName: artwork.firstName || '',
    hasLimitedEditions: artwork.hasLimitedEditions || false,
    hasOpenEditions: artwork.hasOpenEditions || false,
    hasPrint: artwork.hasPrint || false,
    height: artwork.height || 0,
    isReadyToHang: artwork.isReadyToHang || 0,
    idUser: artwork.idUser || 0,
    imageBaseUrl: artwork.imageBaseUrl || '',
    imageUrl: artwork.imageUrl || '',
    isSafe: artwork.isSafe || false,
    isSeoValid: artwork.isSeoValid || false,
    keywords: artwork.keywords || [],
    lastName: artwork.lastName || '',
    legacyArtId: artwork.legacyArtId || 0,
    listPrice: artwork.listPrice || 0,
    listPrices: artwork.listPrices || {},
    materials: artwork.materials || [],
    mediums: artwork.mediums || [],
    minPrintPrice: artwork.minPrintPrice || 0,
    objectID: artwork.objectID || '',
    orientation: artwork.orientation || '',
    originalStatus: artwork.originalStatus || '',
    originalUrl: artwork.originalUrl || '',
    positionID: artwork.positionID || 0,
    price: artwork.price || 0,
    printUrl: artwork.printUrl || '',
    printsAvailability: artwork.printsAvailability || '',
    printsMaterials: artwork.printsMaterials || [],
    printsPriceRanges: artwork.printsPriceRanges || [],
    printsSizeRanges: artwork.printsSizeRanges || [],
    printsSizes: artwork.printsSizes || [],
    printsSizesPrices: artwork.printsSizesPrices || {},
    productStatusRank: artwork.productStatusRank || 0,
    productUrl: artwork.productUrl || '',
    profileUrl: artwork.profileUrl || '',
    size: artwork.size || '',
    sku: artwork.sku || '',
    styles: artwork.styles || [],
    subject: artwork.subject || '',
    toafCities: artwork.toafCities || [],
    uploadedDate: artwork.uploadedDate || 0,
    width: artwork.width || 0,
  }))
